/* tslint:disable */
import {
  HomogenizationOrder,
  Product,
  ProductUom,
  StockLocation,
  StockQuantPackage,
  StockProductionLot,
  Company,
  StockMove,
  Users,
  LotQualityAnalysis
} from '../index';

declare var Object: any;
export interface HomogenizationOrderOutLineInterface {
  "id"?: number;
  "name"?: string;
  "homogenization_order_id"?: number;
  "product_id"?: number;
  "auto_assign_pack"?: boolean;
  "product_uom_id"?: number;
  "product_qty"?: number;
  "location_id"?: number;
  "location_dest_id"?: number;
  "package_id"?: number;
  "prod_lot_id"?: number;
  "company_id"?: number;
  "move_id"?: number;
  "date_done"?: Date;
  "state"?: string;
  "incidents"?: string;
  "user_id"?: number;
  "prod_lot_name"?: string;
  "package_name"?: string;
  "final_state"?: string;
  "quality_analysis_id"?: number;
  homogenizationOrder?: HomogenizationOrder;
  product?: Product;
  productUom?: ProductUom;
  location?: StockLocation;
  locationDest?: StockLocation;
  package?: StockQuantPackage;
  prodLot?: StockProductionLot;
  company?: Company;
  move?: StockMove;
  user?: Users;
  qualityAnalysis?: LotQualityAnalysis;
}

export class HomogenizationOrderOutLine implements HomogenizationOrderOutLineInterface {
  "id": number;
  "name": string;
  "homogenization_order_id": number;
  "product_id": number;
  "auto_assign_pack": boolean;
  "product_uom_id": number;
  "product_qty": number;
  "location_id": number;
  "location_dest_id": number;
  "package_id": number;
  "prod_lot_id": number;
  "company_id": number;
  "move_id": number;
  "date_done": Date;
  "state": string;
  "incidents": string;
  "user_id": number;
  "prod_lot_name": string;
  "package_name": string;
  "final_state": string;
  "quality_analysis_id": number;
  homogenizationOrder: HomogenizationOrder;
  product: Product;
  productUom: ProductUom;
  location: StockLocation;
  locationDest: StockLocation;
  package: StockQuantPackage;
  prodLot: StockProductionLot;
  company: Company;
  move: StockMove;
  user: Users;
  qualityAnalysis: LotQualityAnalysis;
  constructor(data?: HomogenizationOrderOutLineInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `HomogenizationOrderOutLine`.
   */
  public static getModelName() {
    return "HomogenizationOrderOutLine";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of HomogenizationOrderOutLine for dynamic purposes.
  **/
  public static factory(data: HomogenizationOrderOutLineInterface): HomogenizationOrderOutLine{
    return new HomogenizationOrderOutLine(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'HomogenizationOrderOutLine',
      plural: 'HomogenizationOrderOutLines',
      path: 'HomogenizationOrderOutLines',
      idName: 'id',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
        "name": {
          name: 'name',
          type: 'string'
        },
        "homogenization_order_id": {
          name: 'homogenization_order_id',
          type: 'number'
        },
        "product_id": {
          name: 'product_id',
          type: 'number'
        },
        "auto_assign_pack": {
          name: 'auto_assign_pack',
          type: 'boolean'
        },
        "product_uom_id": {
          name: 'product_uom_id',
          type: 'number'
        },
        "product_qty": {
          name: 'product_qty',
          type: 'number'
        },
        "location_id": {
          name: 'location_id',
          type: 'number'
        },
        "location_dest_id": {
          name: 'location_dest_id',
          type: 'number'
        },
        "package_id": {
          name: 'package_id',
          type: 'number'
        },
        "prod_lot_id": {
          name: 'prod_lot_id',
          type: 'number'
        },
        "company_id": {
          name: 'company_id',
          type: 'number'
        },
        "move_id": {
          name: 'move_id',
          type: 'number'
        },
        "date_done": {
          name: 'date_done',
          type: 'Date'
        },
        "state": {
          name: 'state',
          type: 'string'
        },
        "incidents": {
          name: 'incidents',
          type: 'string'
        },
        "user_id": {
          name: 'user_id',
          type: 'number'
        },
        "prod_lot_name": {
          name: 'prod_lot_name',
          type: 'string'
        },
        "package_name": {
          name: 'package_name',
          type: 'string'
        },
        "final_state": {
          name: 'final_state',
          type: 'string'
        },
        "quality_analysis_id": {
          name: 'quality_analysis_id',
          type: 'number'
        },
      },
      relations: {
        homogenizationOrder: {
          name: 'homogenizationOrder',
          type: 'HomogenizationOrder',
          model: 'HomogenizationOrder',
          relationType: 'belongsTo',
                  keyFrom: 'homogenization_order_id',
          keyTo: 'id'
        },
        product: {
          name: 'product',
          type: 'Product',
          model: 'Product',
          relationType: 'belongsTo',
                  keyFrom: 'product_id',
          keyTo: 'id'
        },
        productUom: {
          name: 'productUom',
          type: 'ProductUom',
          model: 'ProductUom',
          relationType: 'belongsTo',
                  keyFrom: 'product_uom_id',
          keyTo: 'id'
        },
        location: {
          name: 'location',
          type: 'StockLocation',
          model: 'StockLocation',
          relationType: 'belongsTo',
                  keyFrom: 'location_id',
          keyTo: 'id'
        },
        locationDest: {
          name: 'locationDest',
          type: 'StockLocation',
          model: 'StockLocation',
          relationType: 'belongsTo',
                  keyFrom: 'location_dest_id',
          keyTo: 'id'
        },
        package: {
          name: 'package',
          type: 'StockQuantPackage',
          model: 'StockQuantPackage',
          relationType: 'belongsTo',
                  keyFrom: 'package_id',
          keyTo: 'id'
        },
        prodLot: {
          name: 'prodLot',
          type: 'StockProductionLot',
          model: 'StockProductionLot',
          relationType: 'belongsTo',
                  keyFrom: 'prod_lot_id',
          keyTo: 'id'
        },
        company: {
          name: 'company',
          type: 'Company',
          model: 'Company',
          relationType: 'belongsTo',
                  keyFrom: 'company_id',
          keyTo: 'id'
        },
        move: {
          name: 'move',
          type: 'StockMove',
          model: 'StockMove',
          relationType: 'belongsTo',
                  keyFrom: 'move_id',
          keyTo: 'id'
        },
        user: {
          name: 'user',
          type: 'Users',
          model: 'Users',
          relationType: 'belongsTo',
                  keyFrom: 'user_id',
          keyTo: 'id'
        },
        qualityAnalysis: {
          name: 'qualityAnalysis',
          type: 'LotQualityAnalysis',
          model: 'LotQualityAnalysis',
          relationType: 'belongsTo',
                  keyFrom: 'quality_analysis_id',
          keyTo: 'id'
        },
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/sdk/models/HomogenizationOrderOutLine.ts